var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEighteen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#557086;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.84,224.72V99.56l-24,25.4-11.24-11.47,37.51-38.62h16.42V224.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.8,186.75c0-20,17.07-33.72,35.71-39.32-17.3-5-33.26-16.18-33.26-35.93-.09-27,26.23-38.9,51.15-38.9s51.43,11.93,51.43,38.9c0,19.75-16.14,31-33.43,35.93,18.5,5.6,35.7,19.34,35.7,39.32,0,25.39-24.28,40.65-53.7,40.65S194.8,212.37,194.8,186.75Zm88.52-2c0-19.52-25.62-27.75-34.82-29-9.25,1.11-35.06,9.25-35.06,29,0,16.19,16.42,26.09,35.06,26.09s34.73-9.9,34.73-26.09ZM281.06,114c0-15.5-14.57-24.7-32.38-24.7S216.31,98.5,216.31,114c0,18.22,23.63,24.28,32.6,25.85,8.7-1.57,32-7.63,32-25.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M361.3,159v30.89H345.58V159H318.52V144.66h27.15V114.87H361.3v29.79h27.15V159Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEighteen);
export default __webpack_public_path__ + "static/media/eighteen.860bc095c15a55df1ec31b2fb28cb2cb.svg";
export { ForwardRef as ReactComponent };